import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import s from 'base/bolt/boltApp.sss';
import Store from 'store/store';
import { navigateInternally } from 'utils/bolt/index';
import { getDynamicData, transformPageData } from 'utils/bolt/dynamicData';
import parseQueryString from 'utils/parseQueryString';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { scale } from 'utils/math';



export default class BoltApp extends BaseComp.default {

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}

		this.setState({
			bgVideo: dynamicData.hero.heroVid,
		});
	}

	async componentDidMount() {
		super.componentDidMount?.();
		const { previewDataPath } = parseQueryString();
		const data = await getDynamicData('landing');
		await this.loadCustomData(data);
		Store.get().set({ dynamicDataLoaded: true });
	}

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const showtimesOpen = Store.get().showtimes?.showtimesOpen;
		if (showtimesOpen) {
			base.attributes.class = joinClasses(base.attributes.class, s.showtimesOpen);
		}
		return base;
	}

}
